import React from "react";
import { debounce } from "lodash-es";

import { AgentWidget } from "./components/AgentWidget";
import { fetchAgents } from "./services/Agents";
import { AgentSource } from "./types/AgentSource";
import { Agent } from "./types/Agent";
import { fetchCountries } from "./services/Countries";
import { Country } from "./types/Country";

export type AppProps = {
  source: AgentSource;
  baseUrl: string;
  institutionCodes?: string[];
};

export function App({ source, baseUrl, institutionCodes = [] }: AppProps) {
  const [isFetching, setIsFetching] = React.useState(false);
  const [agents, setAgents] = React.useState<Agent[]>([]);
  const [search, setSearch] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = React.useState("");
  const [countries, setCountries] = React.useState<Country[]>([]);
  const [selectedCountry, setSelectedCountry] = React.useState<string>("");

  const setSearchDebounced = React.useCallback(
    debounce(setDebouncedSearch, 400),
    [],
  );

  function handleSearch(value: string) {
    setSearch(value);
    setSearchDebounced(value);
  }

  React.useEffect(() => {
    fetchCountries(source, baseUrl)
      .then((countries) => {
        setCountries(countries);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  React.useEffect(() => {
    setIsFetching(true);
    fetchAgents(source, baseUrl, institutionCodes, search, selectedCountry)
      .then((agents) => {
        setAgents(agents);
        setIsFetching(false);
      })
      .catch((error) => {
        console.error(error);
        setAgents([]);
        setIsFetching(false);
      });
  }, [baseUrl, debouncedSearch, selectedCountry]);

  return (
    <AgentWidget
      agents={agents}
      search={search}
      onSearch={handleSearch}
      selectedCountry={selectedCountry}
      countries={countries}
      onCountryChange={setSelectedCountry}
      isFetching={isFetching}
    />
  );
}
